import React from "react";
import { langObj } from "../locale/index";
import en from "../locale/en.json";

let _l = localStorage.getItem("lang") || process.env.REACT_APP_defaultLang;
let l_data = langObj[_l] ? langObj[_l] : en;
export const LangCtx = React.createContext(l_data);

export const PayLoadCtx = React.createContext(null);

export const RoleCtx = React.createContext(null);

export const FileCtx = React.createContext(null);

export const SignalerCtx = React.createContext(null);

export const SpecializationsCtx = React.createContext(null);

export const InstavcCtx = React.createContext(null);

export const GroupChatCtx = React.createContext(null);

export const localRecordingCtx = React.createContext(null);

export const CustomCtx = React.createContext({
    logo: process.env.REACT_APP_logo,
    whiteLable: false,
    subDomain: "",
    name: "InClinix",
    clientstripekey: process.env.REACT_APP_clientstripekey,
    serverstripekey: process.env.REACT_APP_serverstripekey,
});
